import BackLink from 'src/components/back-link/back-link.component'
import { CurecallButton, CurecallTooltip, UploadFilledIcon } from '@honestica/curecall-ui'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import Searchbar from 'src/components/searchbar/searchbar.component'
import { useQuery } from '@tanstack/react-query'
import {
  useCurrentProject,
  WithSpecialAuthorization,
  WithPermission,
} from 'src/providers/current-project.provider'
import {
  EPermissionGrantActions,
  EPermissionGrantSubjects,
  EPermissionSpecialAuthorization,
} from 'src/pages/configuration/permissions/_components/permissions.type'
import { useSession } from 'src/providers/auth.provider'
import { LocalizedLink } from 'src/components/navigation/localized-link.component'
import { ProjectService } from 'src/services/project.service'

const MedicalHeader = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { project, isFeatureActivated } = useCurrentProject()
  const { currentUser } = useSession()
  const { data: uploadConnectors } = useQuery({
    queryKey: ['upload-connectors', project.id],
    queryFn: () => ProjectService.getUploadConnectors(project.id),
  })

  const getAddButton = () => {
    return isFeatureActivated('is-patient-identity-synchronised-automatically') &&
      currentUser?.role !== 'admin' ? (
      <CurecallTooltip
        content={t('components.navigation.header.add-patient-blocked-tooltip')}
        tooltipPosition="bottom-end"
      >
        <CurecallButton isDisabled={true}>
          {t('components.navigation.header.add-patient-button')}
        </CurecallButton>
      </CurecallTooltip>
    ) : (
      <LocalizedLink to={`/${project.id}/medical/patients/add`}>
        <CurecallButton>{t('components.navigation.header.add-patient-button')}</CurecallButton>
      </LocalizedLink>
    )
  }

  const canShowSearchBar =
    !pathname.includes('/projects') && !pathname.includes('/users') && !pathname.includes('/account')

  const canShowAddButton =
    pathname.toString().includes('/patients') ||
    pathname.toString().includes('/planning') ||
    pathname.toString().includes('/dashboard')

  return (
    <div className="c-bg-white c-flex c-m-4 c-mb-0 c-h-max">
      <BackLink />
      {canShowSearchBar && (
        <WithSpecialAuthorization
          requiredSpecialAuthorization={EPermissionSpecialAuthorization.CAN_VIEW_PATIENT_IDENTITIES}
        >
          <WithPermission
            requiredSubject={EPermissionGrantSubjects.PATIENT}
            requiredAction={EPermissionGrantActions.GET}
          >
            <div className="c-w-[1px] c-h-full c-bg-grey-300 c-mx-6" />
            <div className="c-w-full c-max-w-[600px] c-shrink c-pr-4">
              <Searchbar />
            </div>
          </WithPermission>
        </WithSpecialAuthorization>
      )}

      {canShowAddButton && (
        <div className="c-ml-auto c-flex c-gap-4">
          {!!uploadConnectors?.length && (
            <LocalizedLink
              to={`/${project.id}/medical/upload`}
              className="c-font-nexa c-text-base c-flex c-items-center c-gap-2 c-text-primary-800 hover:c-text-primary-600"
            >
              <UploadFilledIcon className="c-w-6" />
              {t('components.navigation.patients-upload')}
            </LocalizedLink>
          )}

          <WithPermission
            requiredSubject={EPermissionGrantSubjects.PATIENT}
            requiredAction={EPermissionGrantActions.CREATE}
          >
            {getAddButton()}
          </WithPermission>
        </div>
      )}
    </div>
  )
}

export default MedicalHeader
